import React from 'react';
import './Hero.css';
import MainBtn from '../Common/Btn';

const Hero = (props) => {
    return ( 
        <>
        <section className='hero'>
            <div className="seperatorLine seperatorLight"></div>
            <h5>Axis’s fully-finished residential properties are complemented by spacious green areas. The community provides top-tier amenities that blend sustainability with exceptional quality of life, setting it apart as a premium destination.</h5>
            <MainBtn btnStyle="heroBtn" btnText="GET CONSULTATION" />
        </section>
        </>
     );
}
 
export default Hero;